/*--------------------------------------
SLIDER ABOUT
 --------------------------------------*/
SliderAboutBanner = {
  init: function () {
    var swiper = new Swiper(".swiper-about-banner", {
      loop: true,
      effect: "fade",
      allowTouchMove: false,
      autoplay: {
        delay: 4000,
        disableOnInteraction: false,
      },
    });
  }
};


$(function () {
  SliderAboutBanner.init();
});